import { meshBounds, useGLTF } from '@react-three/drei'
import { useLoader, useThree } from '@react-three/fiber'
import { useEffect, useRef, useState } from 'react'
import { Audio, AudioListener, AudioLoader } from 'three'

export default function Pipes()
{
    const {nodes} = useGLTF('./models/props/modular_industrial_pipes_01_1k/modular_industrial_pipes_01_1k.gltf')
    
    const heightAboveGround = -1.68
    const offsetLeftWall = -1.75
    const offsetRightWall = -1.661
    
    /**
     * Sounds
     */
    const {camera} = useThree()

    // valve
    const valveSound = useLoader(AudioLoader, './sounds/metalclank3-89222.mp3')
    const playValveSound = () => {
        const listener = new AudioListener()
        camera.add(listener)
        const player = new Audio(listener)
        player.setBuffer(valveSound)
        player.setVolume(0.5)
        player.play()
        player.onEnded(()=>{camera.remove(listener)})
    }

    // water
    const waterSound = useLoader(AudioLoader, './sounds/water-flowing-from-a-pipe-into-the-sewer-94434.mp3')
    const [playerOn, setPlayerOn] = useState(false)
    const waterSoundRef = useRef()
    useEffect(()=>{
        const listener = new AudioListener()
        camera.add(listener)
        const player = new Audio(listener)
        player.setBuffer(waterSound)
        player.setVolume(1)
        player.setLoop(true)
        waterSoundRef.current = player
        return ()=>{camera.remove(listener)}
    },[camera, waterSound])


    // event handler
    const eventHandler = (event) => {
        event.stopPropagation
        playValveSound()
        setPlayerOn(!playerOn)
        if (!playerOn) {
            waterSoundRef.current?.play()
        } else {
            waterSoundRef.current?.pause()
        }
    }

    return <group>

        {/* Short straight Pipe */}
        {/* left */}
        <mesh castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe01.geometry}
            material={nodes.modular_industrial_pipes_01_pipe01.material}
            position={[offsetLeftWall, heightAboveGround, offsetRightWall+0.75]}
            rotation-x={Math.PI/2}
        />
        {/* right */}
        <mesh castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe01.geometry}
            material={nodes.modular_industrial_pipes_01_pipe01.material}
            position={[offsetLeftWall+2.88, heightAboveGround-0.608, offsetRightWall]}
        />

        {/* Long straight Pipe */}
        {/* on the left */}
        <mesh castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe02.geometry}
            material={nodes.modular_industrial_pipes_01_pipe02.material}
            position={[offsetLeftWall, heightAboveGround, offsetRightWall+2.157]}
            rotation-x={Math.PI/2}
        />

        {/* on the right */}
        <mesh
            castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe02.geometry}
            material={nodes.modular_industrial_pipes_01_pipe02.material}
            position={[offsetLeftWall+1.7, heightAboveGround, offsetRightWall]}
            rotation-z={Math.PI/2}
        />

        {/* vertical */}
        <mesh castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe02.geometry}
            material={nodes.modular_industrial_pipes_01_pipe02.material}
            position={[offsetLeftWall+2.88, heightAboveGround+1.155, offsetRightWall]}
        />

        {/* L-Angle Connector */}
        {/* left */}
        <mesh
            castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe04.geometry}
            material={nodes.modular_industrial_pipes_01_pipe04.material}
            position={[offsetLeftWall, heightAboveGround-0.024, offsetRightWall+3.388]}
            rotation={[0, -Math.PI/2, Math.PI/2]}
        />

        {/* middle */}
        <mesh
            castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe04.geometry}
            material={nodes.modular_industrial_pipes_01_pipe04.material}
            position={[offsetLeftWall+0.09, heightAboveGround, offsetRightWall+0.025]}
            rotation={[Math.PI/2, 0, -Math.PI/2]}
        />

        {/* Right */}
        <mesh
            castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe04.geometry}
            material={nodes.modular_industrial_pipes_01_pipe04.material}
            position={[offsetLeftWall+2.88, heightAboveGround+2.429, offsetRightWall-0.085]}
            rotation={[0, -Math.PI/2, Math.PI/2]}
        />

        {/* T-Shaped Connector */}
        <mesh castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe06.geometry}
            material={nodes.modular_industrial_pipes_01_pipe06.material}
            position={[offsetLeftWall+2.88, heightAboveGround, offsetRightWall]}
            rotation={[0, Math.PI, 0]}
        />

        {/* Klappe */}
        <mesh
            castShadow
            geometry={nodes.modular_industrial_pipes_01_pipe08.geometry}
            material={nodes.modular_industrial_pipes_01_pipe08.material}
            position={[offsetLeftWall+0.534, heightAboveGround, offsetRightWall]}
            rotation={[0, 0, Math.PI/2 ]}

            raycast={meshBounds}
            onClick={eventHandler}
            onPointerEnter={()=>{document.body.style.cursor='pointer'}}
            onPointerLeave={()=>{document.body.style.cursor='default'}}
        />

        {/* S-Shaped Pipe - 03 */}
        {/* U-Shaped Pipe - 05 */}
        {/* X-Cross Connector - 07 */}
    </group>

}